<template>
  <v-dialog v-model="showModale" persistent max-width="600px">
    <v-card>
      <v-card-title><span class="text-h6">{{drawerTitle}}</span></v-card-title>
      <v-card-subtitle>{{drawerSubtitle}}</v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="formFieldsValid" lazy-validation>
            <v-list dense>
              <v-list-item
                v-for="item in clienteItems"
                :key="item.label"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <component :is="'p' + item.type" :item="item" @change="componentValueChange" :disabled="readOnly" :updateTrigger="triggerUpdate" :verificaDefault="forceCheckDefault"/>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn class="ma-2" color="default" @click="onAnnulla">Annulla</v-btn>
          <v-btn class="ma-2" color="success" @click="onSalva">Salva Dati</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pSwitch from '@/views/drawer/elementi/switch'
import pDestinazioni from '@/views/drawer/elementi/destinazioni'
import pPaCodiceFiscale from '@/views/drawer/elementi/paCodiceFiscale'
import pPartitaIva from '@/views/drawer/elementi/partitaIva'

export default {
  components: {
    pTesto,
    pMultiselect,
    pSwitch,
    pDestinazioni,
    pPaCodiceFiscale,
    pPartitaIva    
  },
  props: {
    mostraModale : { type: Boolean, default: false },
    clifor: Object
  },
  data: () => ({
    backoffice: null,
    impostazioni: null,
    showModale: false,
    locCliente: null,
    formFieldsValid: true,
    triggerUpdate: 1,
    forceCheckDefault: 1    
  }),
  async mounted() {
    const confBackoffice = await configurazioni.getConfigurazione('backoffice')
    this.backoffice = confBackoffice.pagine
    this.impostazioni = confBackoffice.impostazioni
    this.locCliente = this.clifor // this.$store.getters['clienti/cliente'] || null
  },
  watch: {
    async clifor(value) {
      // this.$refs.form.reset()
      if (value.id) {
        const cliente = await clienti.getCliente(value.id)
        this.locCliente = cliente
      } else {
        this.locCliente = value
      }
    },
    mostraModale(value) {
      if (value) {
        this.showModale = true
      }
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza cliente'
      } else {
        return this.locCliente && this.locCliente._id ? 'Modifica cliente/fornitore' : 'Nuovo cliente/fornitore'
      }
    },
    drawerSubtitle() {
      return this.locCliente ? `${this.locCliente.codice} - ${this.locCliente.ragioneSociale}` : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    clienteItems() {
      if (!this.locCliente || !this.backoffice) {
        return []
      }
      const vars = this.backoffice.clienti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locCliente), ...item})
      }
      return items
    }
  },
  methods: {
    async componentValueChange(data) {
      const { model, subModel, value , azienda, defaultUsed, checkDefault} = data
      let tgt = {}
      if (subModel) {
        dot.str(model, value[subModel], tgt)
      } else {
        dot.str(model, value, tgt)
      }
      _.merge(this.locCliente, tgt)
      await this.$nextTick()
      if (checkDefault) {
        this.forceCheckDefault++
      }
      this.triggerUpdate++
    },
    onAnnulla() {
      // this.$refs.form.reset()
      this.showModale = false
    },
    async onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        await this.salvaSuDB()
      }
      this.showModale = false
    },
    async creaCodiceCliente() {
      const tipo = this.locCliente.amministrativi.cliente ? 'clienti' : 'fornitori'
      const impo = this.impostazioni[tipo]
      var numeratore
      if (impo.tipoNumeratore === '_') {
        const pattern = /[^a-zA-Z0-9-]+/gi
        numeratore = this.locCliente.ragioneSociale.trim().replace(/\s\s+/g, ' ').replace(pattern, '_').toLowerCase()
      } else {
        numeratore = await configurazioni.getNumeratore(impo.tipoNumeratore, true)
      }
      this.locCliente.codice = numeratore
      this.locCliente._id = numeratore
    },
    async salvaSuDB() {
      const id = this.locCliente._id
      let cliente = null
      if (id) {
        cliente = await clienti.modificaCliente(this.locCliente)
        if (!cliente) {
          this.dialogErrore = true
          return
        }
        // this.$store.commit('clienti/CLEAR_EDIT_CLIFOR')
      } else {
        await this.creaCodiceCliente()
        cliente = await clienti.creaCliente(this.locCliente)
        if (!cliente) {
          this.dialogErrore = true
          return
        }
        // this.$store.commit('clienti/CLEAR_CREA_CLIFOR')
        // this.$store.commit('clienti/SET_CLIFOR_CREATO', cliente)
      }
      this.$emit('save', cliente)
    }    
  }
}
</script>